import React from 'react'
import DashboardButton from '../../UI/DashboardButton'
import { colors } from './fieldTheme'

// En-tête commun des écrans terrain : marque Pocketcamp et bouton « Dashboard » (décision 20)
export default function FieldHeader({ showDashboard, onDashboard })
{
	return (
		<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '8px 20px 0', minHeight: 56 }}>
			<div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
				<span style={{ fontSize: 15, fontWeight: 600, color: colors.textSecondary }}>Pocketcamp</span>
				<span aria-hidden="true" style={{ display: 'block', height: 3, width: 56, borderRadius: 3, background: colors.arrival }} />
			</div>
			{showDashboard && <DashboardButton onClick={onDashboard} />}
		</div>
	)
}
